module.exports = __webpack_public_path__ + "img/activity-7.933cb6ed.jpg";